
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import { AppModule } from '@/store/modules/app';
import { SettingsModule } from '@/store/modules/settings';
import Hamburger from '@/components/Hamburger/index.vue';

import SidebarItem from './SidebarItem.vue';
import Logo from './Logo.vue';

import variables from '@/styles/_variables.scss';
import { orderServiceCount } from '@/api/home';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'SideBar',
  components: {
    SidebarItem,
    Logo,
    Hamburger
  }
})
export default class extends Vue {
  private refesh=false;
  private timer:any=''
  private defaultOpeneds: any = []
  created() {
    this.orderServiceCount(1);
    this.timer = setInterval(this.orderServiceCount, 1000 * 60);
  }
  mounted() {
    if (localStorage.getItem('menu')) {
      let loc: any = localStorage.getItem('menu')
      this.defaultOpeneds = JSON.parse(loc)
    } else {
      for (let t = 0; t < this.routes.length; t++) {
        if (this.routes[t].path) {
          this.defaultOpeneds.push(this.routes[t].path)
        }
      }
    }
  }
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
  get sidebar() {
    return AppModule.sidebar;
  }

  get routes() {
    return (this.$router as any).options.routes;
  }

  get activeMenu() {
    const { meta, path } = this.$route;
    if (meta && meta.activeMenu) {
      return meta.activeMenu;
    }
    return path;
  }

  get variables() {
    return variables;
  }

  get isCollapse() {
    return !this.sidebar.opened;
  }

  get showLogo() {
    return SettingsModule.sidebarLogo;
  }
  // toggleSideBar() {
  //   AppModule.ToggleSideBar(false);
  // }
  private orderServiceCount(init:number) {
    if (init !== 1) {
      // || this.$route.path.indexOf('/OrderServicer') === -1
      if (!UserModule.getCompanyId || parseInt(UserModule.getCompanyId) === 0 ) {
        return;
      }
    }
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.user_id = UserModule.getUserId;
    orderServiceCount(pamars).then(res => {
      for (let i = 0; i < this.routes.length; i++) {
        let theOnlyOneChild:any = this.routes[i];
        if (theOnlyOneChild.children && theOnlyOneChild.children.length > 0) {
          for (let m = 0; m < theOnlyOneChild.children.length; m++) {
            let theOnlyOneChild1:any = theOnlyOneChild.children[m];
            if (theOnlyOneChild1.children && theOnlyOneChild1.children.length > 0) {
              for (let k = 0; k < theOnlyOneChild1.children.length; k++) {
                let theOnlyOneChild2:any = theOnlyOneChild1.children[k];
                if (theOnlyOneChild2) {
                  let num = ''
                  if (theOnlyOneChild2.name === 'OrderCustomerUnconfirmed') {
                    if (parseInt(res.data.order_all_wait_confirm) > 99) {
                      num = "99+"
                    } else {
                      num = res.data.order_all_wait_confirm
                    }
                    this.$set(this.routes[i].children[m].children[k].meta, 'num', num);
                  }

                  if (theOnlyOneChild2.name === 'OrderCheckWait') {
                    if (parseInt(res.data.order_all_wait_confirm) > 99) {
                      num = "99+"
                    } else {
                      num = res.data.order_check_wait
                    }
                    this.$set(this.routes[i].children[m].children[k].meta, 'num', num);
                  }

                  if (theOnlyOneChild2.name === 'orderServicerUntreated') {
                    if (parseInt(res.data.dispose_wait) > 99) {
                      num = "99+"
                    } else {
                      num = res.data.dispose_wait
                    }
                    this.$set(this.routes[i].children[m].children[k].meta, 'num', num);
                  }
                  if (theOnlyOneChild2.name === 'orderServicerReport') {
                    if (parseInt(res.data.order_appear) > 99) {
                      num = "99+"
                    } else {
                      num = res.data.order_appear
                    }
                    this.$set(this.routes[i].children[m].children[k].meta, 'num', num);
                  }
                  if (theOnlyOneChild2.name === 'orderServicerUnderway') {
                    if (parseInt(res.data.finish_wait) > 99) {
                      num = "99+"
                    } else {
                      num = res.data.finish_wait
                    }
                    this.$set(this.routes[i].children[m].children[k].meta, 'num', num);
                  }
                  if (theOnlyOneChild2.name === 'orderServiceUnconfirmed') {
                    if (parseInt(res.data.order_service_wait_confirm) > 99) {
                      num = "99+"
                    } else {
                      num = res.data.order_service_wait_confirm
                    }
                    this.$set(this.routes[i].children[m].children[k].meta, 'num', num);
                  }
                  if (theOnlyOneChild2.name === 'orderServicerTimeout') {
                    if (parseInt(res.data.order_timeout) > 99) {
                      num = "99+"
                    } else {
                      num = res.data.order_timeout
                    }
                    this.$set(this.routes[i].children[m].children[k].meta, 'num', num);
                  }
                }
              }
            }
          }
        }
      }
      this.refesh = true;
      this.$nextTick(() => {
        this.refesh = false;
      });
    });
  }

  private closeMenu(val: any) {
    this.defaultOpeneds = this.defaultOpeneds.filter((f: any) => {
      return f !== val
    })
    localStorage.setItem('menu', JSON.stringify(this.defaultOpeneds));
  }
  private openMenu(val: any) {
    this.defaultOpeneds = this.defaultOpeneds.filter((f: any) => {
      return f !== val
    })
    this.defaultOpeneds.push(val);
    localStorage.setItem('menu', JSON.stringify(this.defaultOpeneds));
  }
}
